import { Data2 } from "../../../../../features/data-types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data, O } from "../../../../../features/ui"
import { Currency } from "../../../../../tables/types/types"
import { define } from "../../../../../utils/typeUtils"
import { Discount, Measure } from "../../../../common"
import { useProductActions } from "../../../actions/productActions"
import { MeasureLabel, Product, ProductType } from "../../../state/types"
import { PriceChoice } from "./types"

export const useActions = () => {
    const { createOrUpdateProduct } = useProductActions()

    const submitProduct = async (
        productData: Data,
        code: number,
        priceChoice: PriceChoice,
        basePurchasePrice: number,
        unitTypeId: string,
        units?: number,
        secondaryUnits?: number,
        secondaryUnitTypeId?: string,
        measuresData: Data[] = [],
        unitMeasuresData: Data[] = [],
        measureLabel?: MeasureLabel,
        bonusesData: Partial<Discount>[] = [],
        imageFile?: File,
        description?: string,
        saleYield?: number
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { companyId, id, name, supplierId, supplierCode, categoryId, imageUrl, loted, allowNegativeStock, vatTaxId } = productData
        const type = define(productData.type) as ProductType
        const isBulk = type === ProductType.BULK
        const isPackage = type === ProductType.PACKAGE
        const product: Product = {
            companyId: define(companyId) as string,
            id: define(id) as string,
            code,
            supplierCode: define(supplierCode) as string,
            name: define(name) as string,
            supplierId: define(supplierId) as string,
            categoryId: define(categoryId) as string,
            imageUrl: imageUrl as O<string>,
            description,
            type,
            units: !isBulk ? units : undefined,
            unitTypeId,
            secondaryUnits: !isBulk ? secondaryUnits : undefined,
            secondaryUnitTypeId: !isBulk ? secondaryUnitTypeId : undefined,
            measures: measuresData as Measure[],
            unitMeasures: isPackage ? unitMeasuresData as Measure[] : [],
            measureLabel,
            loted: !!loted,
            // Vender sin stock no aplica a productos con partidas
            allowNegativeStock: !loted && !!allowNegativeStock
        }

        const pricesData: Data2 = {
            purchasePrice: basePurchasePrice,
            vatTaxId,
            saleYield: priceChoice === PriceChoice.GLOBAL_YIELD ? undefined : saleYield,
            bonuses: bonusesData,
            currency: Currency.ARS
        }

        await createOrUpdateProduct(product, pricesData, imageFile)
        Emitter.emit(Event.DB_SUBMIT_DONE, true)
    }

    return {
        submitProduct
    }
}
